export const isPhoneValid = (text: string) => {
    if(text){
        return /^[\+]?[0-9]{9,}$/.test(text);
    }else{
        return true;
    }
}

export const isEmailValid = (text: string) => {
    if(text){
        return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(text);
    }else{
        return true;
    }
}

export const isValidHttpUrl = (link: string) => {

    const splittedLink = link ? link.split(".") : [] ;

    if (splittedLink.length <= 1) return false;
    for (let i = 0; i < splittedLink.length; i++) {
      if (splittedLink[i].length === 0) {
        return false;
      }
    }

    return true;
}

export const isFaxValid = (text: string) => {
    if(text){
        return /^\+?\(([0-9]{1,3})\)\s[0-9]{3}\-[0-9]{4}/.test(text);
    }else{
        return true;
    }
}